import React, { createContext, useContext, useState, useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_URL || '';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

function readStoredLanguage() {
  const sessionLang = sessionStorage.getItem('language');
  if (sessionLang === 'es' || sessionLang === 'en') {
    return sessionLang;
  }
  const localLang = localStorage.getItem('language');
  if (localLang === 'es' || localLang === 'en') {
    return localLang;
  }
  return 'es';
}

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(readStoredLanguage);
  const [languageSelectorEnabled, setLanguageSelectorEnabled] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/api/config`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : null))
      .then((cfg) => {
        if (cancelled) return;
        const enabled = cfg?.languageSelectorEnabled === true;
        setLanguageSelectorEnabled(enabled);
        if (!enabled) {
          setLanguage('es');
          sessionStorage.setItem('language', 'es');
          localStorage.setItem('language', 'es');
        }
      })
      .catch(() => {
        if (cancelled) return;
        setLanguageSelectorEnabled(false);
        setLanguage('es');
        sessionStorage.setItem('language', 'es');
        localStorage.setItem('language', 'es');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  const changeLanguage = async (lang) => {
    if (!languageSelectorEnabled) return;
    if (lang !== 'es' && lang !== 'en') return;
    setLanguage(lang);
    sessionStorage.setItem('language', lang);
    localStorage.setItem('language', lang);
  };

  return (
    <LanguageContext.Provider
      value={{ language, changeLanguage, loading, languageSelectorEnabled }}
    >
      {children}
    </LanguageContext.Provider>
  );
};
